import React from 'react';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Header } from './layout/Header';
import Pages from './pages';

export default () => {
    /** loop in all the registered pages and build a sitemap */
    const SiteMap = () => <Switch>
        <Route path={`/`} exact component={Pages.Auth} />
        {
            Object.keys(Pages).map(
                (key, index) => <Route exact key={index} path={`/${key.toLowerCase()}`} component={Pages[key]} />
            )
        }
    </Switch>
    /** 
     * then return the routes,
     * we got a header in all the pages
     */
    return <Router>
        <Route path="/" render={props => <Header {...props} />} />
        <SiteMap />
    </Router>
}
